import { makeServerPut, makeServerPost, makeServerRequest, makeServerDelete } from './util';

const apiPrefix = "/api/v1/branches/";

export const fetchOperatorSuccess = (operator) => {
    return {
        type: "FETCH_OPERATOR_SUCCESS",
        payload: operator
    };
};

export const fetchOperatorFailure = (error) => {
    return {
        type: "FETCH_OPERATOR_FAILURE",
        payload: error
    };
};

export const fetchOperator = (branchId, id) => {
    return (dispatch) => {
        dispatch({type: "FETCH_OPERATOR"});
        if(id === 0) {
            dispatch({
                type: "FETCH_OPERATOR_SUCCESS",
                payload: {id: 0}
            });

        }
        return makeServerRequest(apiPrefix + branchId + "/operators/" + id).then(
            response => dispatch(fetchOperatorSuccess(response.data))
        ).catch(
            error => dispatch(fetchOperatorFailure(error))
        );
    }
};

export const fetchOperatorsFailure = (error) => {
    return {
        type: "FETCH_OPERATORS_FAILURE",
        payload: error
    };
};

export const fetchOperatorsSuccess = (operators) => {
    return {
        type: "FETCH_OPERATORS_SUCCESS",
        payload: operators
    };
};

export const fetchOperators = (branchId) => {
    return (dispatch) => {
        dispatch({type: "FETCH_OPERATORS"});

        return makeServerRequest(apiPrefix + branchId + "/operators").then(
            response => dispatch(fetchOperatorsSuccess(response.data))
        ).catch(
            error => dispatch(fetchOperatorsFailure(error))
        );
    };
};

export const persistOperatorSuccess = (operator) => {
    return {
        type: "PERSIST_OPERATOR_SUCCESS",
        payload: operator
    };
};

export const persistOperatorFailure = (error) => {
    return {
        type: "PERSIST_OPERATOR_FAILURE",
        payload: error
    };
};

export const persistOperator = (branchId, operator) => {

    return (dispatch) => {
        dispatch({type: "PERSIST_OPERATOR"});

        if(operator.id === 0){
            return makeServerPost(apiPrefix + branchId + "/operators/", operator).then(
                response => dispatch(persistOperatorSuccess(response.data))
            ).catch(
                error => dispatch(persistOperatorFailure(error))
            );
        } else {
            return makeServerPut(apiPrefix + branchId + "/operators/" + operator.id, operator).then(
                response => dispatch(persistOperatorSuccess(response.data))
            ).catch(
                error => dispatch(persistOperatorFailure(error))
            );

        }
    };
};

export const deleteOperatorSuccess = (operator) => {
    return {
        type: "DELETE_OPERATOR_SUCCESS",
        payload: operator
    };
};

export const deleteOperatorFailure = (error) => {
    return {
        type: "DELETE_OPERATOR_FAILURE",
        payload: error
    };
};

export const deleteOperator = (branchId, operatorId) => {

    return (dispatch) => {
        dispatch({type: "DELETE_OPERATOR", payload: operatorId});

        return makeServerDelete(apiPrefix + branchId + "/operators/" + operatorId).then(
            response => dispatch(deleteOperatorSuccess(response.data))
        ).catch(
            error => dispatch(deleteOperatorFailure(error))
        );
    };
};




// WEBPACK FOOTER //
// ./src/store/actions/operators.js